import React from 'react';
import { Link } from "react-router-dom";

import imgapple from '../../img/applelogo.svg'
import imggoogle from '../../img/googleplay.png'

function NavRodape() {
    const menuLinks = [
        { name: 'SOBRE', path: '/Sobre', icon: '📖' },
        { name: 'SUPORTE', path: '/Suporte', icon: '🛠️' },
        { name: 'TERMOS', path: '/Termos', icon: '📋' },
        { name: 'POLÍTICAS', path: '/Politicas', icon: '🔐' }
    ];



    return (
        <footer 
            className="relative mt-6 md:mt-8 overflow-hidden bg-background"
            role="contentinfo"
        >
            {/* Simplified background */}
            <div className="absolute inset-0 bg-background" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/3 via-transparent to-transparent" />

            <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">

                {/* Main Content Grid */}
                <div className="py-8 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
                    
                    {/* Navigation Column */}
                    <div className="lg:col-span-1">
                        <h3 className="text-lg font-bold text-text mb-4 flex items-center gap-2">
                            <span className="text-primary">🔗</span>
                            Links Rápidos
                        </h3>
                        <nav className="space-y-2" role="navigation" aria-label="Menu do rodapé">
                            {menuLinks.map((link, index) => (
                                <Link 
                                    key={index}
                                    to={link.path}
                                    className="group flex items-center gap-2 text-text-subtle hover:text-text transition-all duration-300 p-2 rounded-lg hover:bg-surface/50"
                                    aria-label={`Ir para página ${link.name.toLowerCase()}`}
                                >
                                    <span className="text-sm">
                                        {link.icon}
                                    </span>
                                    <span className="font-medium group-hover:text-primary text-sm">
                                        {link.name}
                                    </span>
                                </Link>
                            ))}
                        </nav>
                    </div>

                    {/* Download Apps Column */}
                    <div className="lg:col-span-1">
                        <h3 className="text-lg font-bold text-text mb-4 flex items-center gap-2">
                            <span className="text-primary">📱</span>
                            Baixe o App
                        </h3>
                        <div className="space-y-3">
                            <p className="text-text-subtle text-sm leading-relaxed">
                                Acesso completo ao SMIZE TV. Disponível para iOS e Android.
                            </p>
                            
                            <div className="space-y-2">
                                <a 
                                    href={import.meta.env.VITE_APPLE_STORE_URL || "https://apps.apple.com/br/app/smize-tv/id6449884293"} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="group flex items-center gap-3 bg-surface/50 hover:bg-surface border border-border hover:border-primary/30 rounded-lg p-3 transition-all duration-300"
                                    aria-label="Baixar SMIZE TV na App Store"
                                >
                                    <img 
                                        src={imgapple} 
                                        alt="App Store" 
                                        className="w-8 h-8 rounded-lg" 
                                    />
                                    <div className="flex-1">
                                        <div className="text-text font-semibold text-sm">App Store</div>
                                        <div className="text-text-subtle text-xs">iPhone & iPad</div>
                                    </div>
                                </a>

                                <a 
                                    href={import.meta.env.VITE_GOOGLE_PLAY_URL || "https://play.google.com/store/apps/details?id=com.smizeapp"} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="group flex items-center gap-3 bg-surface/50 hover:bg-surface border border-border hover:border-primary/30 rounded-lg p-3 transition-all duration-300"
                                    aria-label="Baixar SMIZE TV no Google Play"
                                >
                                    <img 
                                        src={imggoogle} 
                                        alt="Google Play" 
                                        className="w-8 h-8 rounded-lg" 
                                    />
                                    <div className="flex-1">
                                        <div className="text-text font-semibold text-sm">Google Play</div>
                                        <div className="text-text-subtle text-xs">Android</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Contact Column */}
                    <div className="lg:col-span-1">
                        <h3 className="text-lg font-bold text-text mb-4 flex items-center gap-2">
                            <span className="text-primary">💬</span>
                            Fale Conosco
                        </h3>
                        <div className="space-y-4">
                            <p className="text-text-subtle text-sm leading-relaxed">
                                Entre em contato pelo WhatsApp e receba suporte especializado.
                            </p>
                            
                            <a
                                href={`https://wa.me/${import.meta.env.VITE_WHATSAPP_NUMBER || '5521998851057'}?text=Ol%C3%A1%21%20Gostaria%20de%20receber%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20Smize%20TV.%20Pode%20me%20ajudar%3F`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group inline-flex items-center gap-2 bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400 text-white font-semibold px-4 py-3 rounded-lg transition-all duration-300 w-full justify-center text-sm"
                                aria-label="Entrar em contato pelo WhatsApp"
                            >
                                <img
                                    src={import.meta.env.VITE_WHATSAPP_ICON || "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"}
                                    alt=""
                                    className="w-5 h-5"
                                    aria-hidden="true"
                                />
                                <span>WhatsApp</span>
                            </a>

                            {/* Social Media */}
                            <div className="pt-3 border-t border-border">
                                <div className="text-text-subtle text-xs mb-2">Siga-nos nas redes</div>
                                <div className="flex gap-2">
                                    <a
                                        href="https://www.instagram.com/smize.tv/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 hover:from-purple-400 hover:to-pink-400 rounded-lg flex items-center justify-center transition-all duration-300"
                                        aria-label="Seguir SMIZE TV no Instagram"
                                    >
                                        <span className="text-sm text-white">📷</span>
                                    </a>
                                    
                                    {['📘', '🐦', '🎵'].map((icon, index) => (
                                        <button
                                            key={index}
                                            className="w-8 h-8 bg-surface/50 hover:bg-surface border border-border hover:border-primary/30 rounded-lg flex items-center justify-center transition-all duration-300"
                                            aria-label={`Rede social ${index + 1}`}
                                        >
                                            <span className="text-sm">{icon}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="border-t border-border pt-4 pb-4">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-3">
                        <div className="text-center md:text-left">
                            <p className="text-text-subtle text-xs">
                                © 2024 SMIZE TV - Todos os direitos reservados
                            </p>
                        </div>
                        
                        <div className="flex items-center gap-3 text-text-subtle/70 text-xs">
                            <span>🔒 Seguro</span>
                            <span>⚡ Rápido</span>
                            <span>📱 Responsivo</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default NavRodape;